// src/services/abstract/UserService.ts

import type { User } from '@/types/UserState';
import type {
  NotificationsPayloadDTO,
  NotificationStatus,
  NotificationQueryParams,
  NotificationStatusDTO,
} from '@/types/NotificationDTOs';
import type {
  CreateExternalUserPayload,
  CreateExternalUserResponse,
} from '@/types/create-six.types';
import type { ExternalUserDTO } from '@/types/external-users.types';

export abstract class UserService {
  abstract getMe(id: string): Promise<User>;
  abstract getEncapsKey(id: string): Promise<{ encapsKey: string; mlkemKeyVersion: string }>;
  abstract getDecapsKey(id: string): Promise<{ decapsKey: string }>;
  abstract markNotificationRead(
    notificationId: string,
    status: NotificationStatus
  ): Promise<NotificationStatusDTO>;
  abstract getNotifications(params?: NotificationQueryParams): Promise<NotificationsPayloadDTO>;
  abstract createNewExternalUser(
    payload: CreateExternalUserPayload
  ): Promise<CreateExternalUserResponse>;
  abstract listExternalUsers(): Promise<ExternalUserDTO[]>;
  abstract deleteExternalUser(id: string): Promise<void>;
}
